import axios from 'axios';
import { API, authHeaders } from './client';

export const sendFree = (token, data) =>
  axios.post(`${API}/send/free`, data, authHeaders(token)).then(r => r.data);

export const sendCheckout = (token, data) =>
  axios.post(`${API}/send/checkout`, data, authHeaders(token)).then(r => r.data);
